export default "__VITE_ASSET__DnhJJ27k__"